import { lazy } from 'react';

export const AffiliateReferralsPageLazy = lazy(
    () => import('./affiliate-referrals-page'),
);
